import { z } from 'zod';

import { ValidUuidOrNotSetSchema } from '@vestigas/utils';

import { AddressModel } from './zodAddressModel';

/**
 * Zod validation schema for parties of a delivery note.
 */
export const DeliveryPartyModel = z.object({
  id: ValidUuidOrNotSetSchema,
  legalOrganization: z
    .object({
      address: AddressModel.optional(),
      companyAccountId: ValidUuidOrNotSetSchema,
      id: ValidUuidOrNotSetSchema,
      name: z.string().optional(),
    })
    .optional(),
  tradeContact: z
    .object({
      departmentName: z.string().optional(),
      jobTitle: z.string().optional(),
      personName: z.string().optional(),
      universalCommunication: z.object({
        completeNumber: z.string().optional(),
        email: z.string().optional(),
        type: z.string().optional(),
      }),
    })
    .optional(),
});
